module.exports = __webpack_public_path__ + "static/media/Playbook.58d520fd.svg";